import { Select, Textarea, TextInput } from "../../../common";

export type SynapseKindNeuralProfileEntry = {
  id: string;
  synapseKindNeuralProfileId: string;
  synapseKindId: string;
  baseWeightMin: string;
  baseWeightMax: string;
  baseDelayMinMs: string;
  baseDelayMaxMs: string;
  basePlasticityRule: string;
  canAdaptWeights: string;
  canAdaptDelays: string;
  allowedOverrideFields: string;
  validationRanges: string;
};

const booleanSelectOptions = [
  { value: "true", label: "Yes" },
  { value: "false", label: "No" },
];

interface SynapseKindNeuralProfileFormProps {
  profile: SynapseKindNeuralProfileEntry;
  onChange: (profileId: string, field: keyof SynapseKindNeuralProfileEntry, value: string) => void;
}

const SynapseKindNeuralProfileForm: React.FC<SynapseKindNeuralProfileFormProps> = ({
  profile,
  onChange,
}) => {
  return (
    <div className="node-kind-builder__grid">
      <TextInput
        id={`synapse-neural-weightMin-${profile.id}`}
        name="baseWeightMin"
        type="number"
        step="0.01"
        value={profile.baseWeightMin}
        onChange={(event) =>
          onChange(profile.id, "baseWeightMin", event.target.value)
        }
        placeholder="0.0"
        variant="modal"
        label="BaseWeightMin"
      />
      <TextInput
        id={`synapse-neural-weightMax-${profile.id}`}
        name="baseWeightMax"
        type="number"
        step="0.01"
        value={profile.baseWeightMax}
        onChange={(event) =>
          onChange(profile.id, "baseWeightMax", event.target.value)
        }
        placeholder="1.0"
        variant="modal"
        label="BaseWeightMax"
      />
      <TextInput
        id={`synapse-neural-delayMin-${profile.id}`}
        name="baseDelayMinMs"
        type="number"
        step="0.1"
        value={profile.baseDelayMinMs}
        onChange={(event) =>
          onChange(profile.id, "baseDelayMinMs", event.target.value)
        }
        placeholder="0"
        variant="modal"
        label="BaseDelayMinMs"
      />
      <TextInput
        id={`synapse-neural-delayMax-${profile.id}`}
        name="baseDelayMaxMs"
        type="number"
        step="0.1"
        value={profile.baseDelayMaxMs}
        onChange={(event) =>
          onChange(profile.id, "baseDelayMaxMs", event.target.value)
        }
        placeholder="100"
        variant="modal"
        label="BaseDelayMaxMs"
      />
      <TextInput
        id={`synapse-neural-plasticity-${profile.id}`}
        name="basePlasticityRule"
        type="text"
        value={profile.basePlasticityRule}
        onChange={(event) =>
          onChange(profile.id, "basePlasticityRule", event.target.value)
        }
        placeholder="STDP, HEBBIAN, etc."
        variant="modal"
        label="BasePlasticityRule"
      />
      <Select
        id={`synapse-neural-canAdaptWeights-${profile.id}`}
        name="canAdaptWeights"
        value={profile.canAdaptWeights}
        onChange={(event) =>
          onChange(profile.id, "canAdaptWeights", event.target.value)
        }
        variant="modal"
        options={booleanSelectOptions}
        placeholder="Select option"
        label="CanAdaptWeights"
      />
      <Select
        id={`synapse-neural-canAdaptDelays-${profile.id}`}
        name="canAdaptDelays"
        value={profile.canAdaptDelays}
        onChange={(event) =>
          onChange(profile.id, "canAdaptDelays", event.target.value)
        }
        variant="modal"
        options={booleanSelectOptions}
        placeholder="Select option"
        label="CanAdaptDelays"
      />
      <div className="node-kind-builder__grid-span-2">
        <Textarea
          id={`synapse-neural-allowedOverrides-${profile.id}`}
          name="allowedOverrideFields"
          rows={4}
          value={profile.allowedOverrideFields}
          onChange={(event) =>
            onChange(profile.id, "allowedOverrideFields", event.target.value)
          }
          placeholder='["baseWeightMin","baseWeightMax","baseDelayMinMs"]'
          variant="modal"
          label="AllowedOverrideFields (JSON)"
        />
      </div>
      <div className="node-kind-builder__grid-span-2">
        <Textarea
          id={`synapse-neural-validation-${profile.id}`}
          name="validationRanges"
          rows={4}
          value={profile.validationRanges}
          onChange={(event) =>
            onChange(profile.id, "validationRanges", event.target.value)
          }
          placeholder='{"baseWeightMin": {"min": 0, "max": 1}, "baseWeightMax": {"min": 0, "max": 1}}'
          variant="modal"
          label="ValidationRanges (JSON)"
        />
      </div>
    </div>
  );
};

export default SynapseKindNeuralProfileForm;



